import React, { useState, useEffect, useMemo } from 'react'
import { useWeb3React } from '@web3-react/core'
import { Contract, providers, utils } from 'ethers'
import CUSTODIAN_ABI from '../constants/abis/custodian.json'
import {
  CUSTODIAN_ADDRESS,
  PAGE_NAME,
  PAGE_SWAP_NAME,
  PAGE_AFFILIATE_NAME,
} from '../constants/'
import { useToken } from './useToken'
import { displayCurrency, displayCurrencyForInput } from '../utils/helpers'
import { useDispatch, useSelector } from 'react-redux'
import {
  fetchAffLink,
  setStateKey,
  fetchAffInfo,
} from '../redux/slices/affiliateSlice'
import { useConnectWallet } from './useConnectWallet'
import { useCustodainContract, useDexContract } from './useContract'
import { useDex } from './useDex'
import { useStake } from './useStake'
import { shortenAddress, isCorrectNetwork } from '../utils'
import { useModalStatus } from "./useModalStatus"
import { closeModalStatus } from '../redux/slices/modalStatusSlice'
import { fetchUserCommission, withdrawCommission } from '../redux/slices/commissionSlice'
import { reactLocalStorage } from 'reactjs-localstorage'
import { getCookieData, readCookie ,setCookieData ,deleteCookieData} from '../utils/cookieHelper'

export const useAffiliate = () => {
  const {
    account,
    library,
    chainId,
    // network,
  } = useWeb3React<providers.Web3Provider>()

  const { allowance, approve, getBalanceOfToken } = useToken()
  const { isLoginAff, isSignIn, setStateLoginAff } = useConnectWallet()

  // const [contract, setContract] = useState<any>(null)
  const [isStaking, setIsStaking] = useState<boolean | null>(null)
  const [balanceOfStaking, setBalanceOfStaking] = useState<string | undefined>(
    '',
  )

  const [mininumRate, setMininumRate] = useState<string>('')
  // const [isApprovedToken, setIsApprovedToken] = useState<string>('none')

  const dispatch = useDispatch()
  const affState = useSelector((state) => state.affiliate)
  const contract = useCustodainContract()
  const dexContract = useDexContract()
  const { checkStaking ,getStakeBlance } = useStake()
  const {  
    setShowModalStaus, 
    modalStatusState ,
    setCloseModalStatus,
    STATUS_TYPE,
    setModalForHandleError,
  } = useModalStatus()
  const { isShowModalStatus } = modalStatusState

  useEffect(() => {
    ;(async () => {
      if (library) {
        const resContract = contract
        if (resContract && isCorrectNetwork(chainId)) {
          const isStaking = await checkStaking(account)
          getStakeBlance(account)
          getMininumRate(resContract)
          if (isStaking) {
            getDashboradInfo()
          }
        }
      }
    })()
  }, [library])

  useEffect(() => {
    const isLogin = isSignIn()
    setStateLoginAff(isLogin)
  }, [])

  const approveToken = async () => {
    setShowModalStaus(STATUS_TYPE.WAITING)
    try {
      const isApproved = await approve(CUSTODIAN_ADDRESS, mininumRate)
      if (isApproved) {
        getBalanceOfToken(account)
        dispatch(setStateKey({ key: 'isApprovedToken', value: 'approved' }))
        setCloseModalStatus()
      } else {
        setCloseModalStatus()
      }
    } catch (err) {
      setModalForHandleError(err)
    }
  }

  const checkTokenApprovel = async () => {
    const resultToken = await allowance(account, CUSTODIAN_ADDRESS)

    const isApproved = Number(displayCurrencyForInput(resultToken)) > 0

    if (isApproved) {
      getBalanceOfToken(account)
      dispatch(setStateKey({ key: 'isApprovedToken', value: 'approved' }))
      setCloseModalStatus()
    } else {
      dispatch(setStateKey({ key: 'isApprovedToken', value: 'unapproved' }))
      setCloseModalStatus()
    }
  }
  // move to useStake hook
  // const getStakeBlance = async (contract: any) => {
  //   const balance = await contract.balanceOf(account)
  //   setBalanceOfStaking(displayCurrencyForInput(balance))
  //   dispatch(setStateKey({ key: 'balanceOfStaking', value: displayCurrencyForInput(balance)}))
  // }

  const getMininumRate = async (contract: any) => {
    const rate = await contract.mininumRate()
    setMininumRate(displayCurrency(rate, 0))
  }

  const staking = async (refCode: String) => {
    try {
      setShowModalStaus(STATUS_TYPE.WAITING)
      const response = await contract.stakeTokens(
        utils.parseEther(mininumRate),
        refCode,
      )
      // watchEvent(contract)
      await callbackStake(response)
      //TODO : set show dashboard
      getStakeBlance(account)
      getDashboradInfo()
    } catch (ex) {
      setModalTxStatus('fail', ex)
    }
  }

  const createAffLink = () => {
    //TODO:  get Aff link
    if (isSignIn() && affState.link == '') {
      dispatch(fetchAffLink())
    }
  }

  const getAffLink = () => {
    if (!affState.info) return ''

    const { referralKey } = affState.info
    return `${PAGE_AFFILIATE_NAME}${referralKey}`
  }

  const unStake = async () => {
    try {
      const response = await contract.unstakeTokens()
      await callbackStake(response)
    } catch (ex) {
      setModalTxStatus('fail', ex)
    }
  }

  const callbackStake = async (response: any) => {
    setShowModalStaus(STATUS_TYPE.WAITING)
    const staked = await response.wait()

    if (staked.status === 1) {
      setModalTxStatus('success', null)
      checkStaking(account)
    } else {
      //TODO : fail
      throw new Error('Transfer failed')
    }
  }

  const setModalTxStatus = (status: string, ex: any) => {
    if (status == 'success') {
      setShowModalStaus(STATUS_TYPE.SUCCESS)
      // setModalStatus(true, 'Transaction submited', 'success')
    } else {
      setModalForHandleError(ex)
    }
  }

  const getDashboradInfo = () => {
    const accessToken = reactLocalStorage.get('accessToken')
    if (accessToken) {
       dispatch(fetchAffInfo())
    }

  }

  const getReward = async () => {
   
    dispatch(withdrawCommission())
    
    //setShowModalStaus(STATUS_TYPE.SUCCESS)

    /*
    try {
      setShowModalStaus(STATUS_TYPE.WAITING)

      const { commission } = affState
      const amount = utils.parseEther(commission)
      const result = await dexContract.withdrawCommission(amount)
      const resultConfirm = await result.wait()
      if (resultConfirm.status === 1) {
        setShowModalStaus(STATUS_TYPE.SUCCESS)
        //dispatch(fetchUserCommission(account))
      } else {
        throw new Error('Transfer failed')
      }
    } catch (ex) {
      setShowModalStaus(ex)
    }*/
  }

  // const watchEvent = (contract: any) => {
  //   contract.on('StakeToken', () => {
  //     //TODO: somthing went event bought
  //     console.log('StakeToken')
  //   })
  // }

  return {
    // isApprovedToken,
    isStaking,
    staking,
    approveToken,
    checkTokenApprovel,
    createAffLink,
    affState,
    getAffLink,
    balanceOfStaking,
    mininumRate,
    unStake,
    getReward,
  }
}
